export const getNameFromUser = (
  user?:
    | Partial<{
        firstName: string;
        lastName: string;
      }>
    | null
    | undefined,
  firstOnly?: boolean,
) =>
  user
    ? firstOnly
      ? user.firstName
      : `${user.firstName} ${user.lastName}`
    : "";
